var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _g3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g4, _path25, _g5, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _g6, _path92, _path93, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketLaunchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2407_17954)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 46,
    fill: "#F1687B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6088 64.3636C45.6088 64.3636 37.269 61.2348 35.4838 69.3501L37.2458 68.9989C37.2458 68.9989 35.1812 71.3734 34.4492 75.8764C38.9273 75.0045 41.2363 72.8668 41.2363 72.8668L40.9401 74.639C48.996 72.6019 45.6088 64.3636 45.6088 64.3636Z",
    fill: "url(#paint0_linear_2407_17954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6094 64.3641C45.6094 64.3641 40.4073 62.4124 39.2938 67.4745L40.3929 67.2553C40.3929 67.2553 39.105 68.7365 38.6484 71.5453C41.4418 71.0014 42.8819 69.668 42.8819 69.668L42.6972 70.7733C47.7222 69.5028 45.6094 64.3641 45.6094 64.3641Z",
    fill: "url(#paint1_linear_2407_17954)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5035 63.9497L45.8125 58.3192L47.3807 56.7412L53.0717 62.3719L51.5035 63.9497Z",
    fill: "url(#paint2_linear_2407_17954)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1311 49.2674C50.1311 49.2674 44.8455 48.8769 42.6769 51.0579C40.3368 53.4113 38.3987 56.291 36.8337 60.4069C35.9987 62.6033 38.2038 60.3332 39.6666 58.996C42.2274 56.6551 43.4898 56.7026 45.928 57.2612C45.928 57.2612 47.2426 54.571 50.1311 49.2674Z",
    fill: "url(#paint3_linear_2407_17954)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M50.1311 49.2674C50.1311 49.2674 44.8455 48.8769 42.6769 51.0579C40.3368 53.4113 38.3987 56.291 36.8338 60.4069C36.6771 60.8188 36.6275 61.0736 36.6597 61.2069C36.6597 61.2069 38.9096 55.993 41.3744 53.4416C43.8393 50.8902 45.4825 49.9364 50.1311 49.2674Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5701 59.5957C60.5701 59.5957 61.006 64.866 58.8384 67.048C56.4994 69.4027 53.6296 71.3605 49.5179 72.9564C47.3238 73.8081 49.5803 71.5888 50.9081 70.1181C53.2326 67.5434 53.1744 66.2843 52.5942 63.8565C52.5942 63.8565 55.279 62.5222 60.5701 59.5957Z",
    fill: "url(#paint4_linear_2407_17954)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2147 39.7099C78.0934 34.0139 76.9734 32.6742 76.9734 32.6742C76.9734 32.6742 75.6212 31.5681 69.9201 32.4926C63.8984 33.469 60.0764 37.1715 57.4737 39.7454C54.1062 43.0755 48.5528 50.7382 45.9277 57.2609L49.2779 60.541L52.5936 63.8559C59.1085 61.1819 66.7415 55.5766 70.0506 52.1889C72.6083 49.5706 76.2866 45.7261 77.2147 39.7099Z",
    fill: "url(#paint5_linear_2407_17954)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7793 58.0926L49.2797 60.5407L52.5954 63.8556C59.1104 61.1816 66.7433 55.5763 70.0524 52.1886C72.6102 49.5701 76.2886 45.7256 77.2165 39.7095C78.0952 34.0136 76.9753 32.6738 76.9753 32.6738",
    fill: "url(#paint6_linear_2407_17954)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M46.4023 57.7246L52.1067 63.3682",
    stroke: "black",
    strokeWidth: 1.8919,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9277 57.2605L49.2779 60.5407L52.5936 63.8556C53.9103 63.3151 55.2728 62.6536 56.6358 61.9161L47.8374 53.2109C47.1099 54.5773 46.4583 55.9423 45.9277 57.2605Z",
    fill: "url(#paint7_linear_2407_17954)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8628 55.2812L52.5937 63.8557L51.9472 63.4303L51.5029 63.9492L49.293 61.7628L54.8628 55.2812Z",
    fill: "url(#paint8_linear_2407_17954)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9727 34.0508L75.6961 44.6606",
    stroke: "black",
    strokeWidth: 1.8919,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9744 32.6742C76.9744 32.6742 75.6222 31.5681 69.921 32.4926C68.0737 32.7922 66.4342 33.349 64.9727 34.0504L75.6961 44.6602C76.3868 43.196 76.931 41.5555 77.2157 39.7099C78.0943 34.0141 76.9744 32.6742 76.9744 32.6742Z",
    fill: "url(#paint9_linear_2407_17954)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2407_17954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 32,
    width: 33,
    height: 32
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2147 39.7099C78.0934 34.0139 76.9734 32.6742 76.9734 32.6742C76.9734 32.6742 75.6212 31.5681 69.9201 32.4926C63.8984 33.469 60.0764 37.1715 57.4737 39.7454C54.1062 43.0755 48.5528 50.7382 45.9277 57.2609L49.2779 60.541L52.5936 63.8559C59.1085 61.1819 66.7415 55.5766 70.0506 52.1889C72.6083 49.5706 76.2866 45.7261 77.2147 39.7099Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2407_17954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.74 46.9489L62.8301 34.303L63.3745 33.7471L76.2846 46.3929L75.74 46.9489Z",
    fill: "url(#paint10_linear_2407_17954)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2407_17954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 32,
    width: 33,
    height: 32
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2147 39.7099C78.0934 34.0139 76.9734 32.6742 76.9734 32.6742C76.9734 32.6742 75.6212 31.5681 69.9201 32.4926C63.8984 33.469 60.0764 37.1715 57.4737 39.7454C54.1062 43.0755 48.5528 50.7382 45.9277 57.2609L49.2779 60.541L52.5936 63.8559C59.1085 61.1819 66.7415 55.5766 70.0506 52.1889C72.6083 49.5706 76.2866 45.7261 77.2147 39.7099Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2407_17954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9472 47.9765L62.0371 35.3307L62.4004 34.96L75.3105 47.6058L74.9472 47.9765Z",
    fill: "url(#paint11_linear_2407_17954)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M47.8379 53.2109L56.6374 61.9166",
    stroke: "black",
    strokeWidth: 1.8919,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8178 54.9672C54.8178 54.9672 54.3265 54.2065 49.5788 58.9837C44.8309 63.7608 40.7819 68.337 41.1592 68.7103C41.5365 69.0836 46.0886 65.0053 50.8364 60.2282C55.5843 55.4509 54.8178 54.9672 54.8178 54.9672Z",
    fill: "url(#paint12_linear_2407_17954)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M54.8178 54.9672C54.8178 54.9672 54.3265 54.2065 49.5788 58.9837C44.8309 63.7608 40.7819 68.337 41.1592 68.7103C41.1592 68.7103 42.4866 66.8029 46.0496 63.0083C49.6128 59.2137 53.6986 55.0667 54.8178 54.9672Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0548 52.1265C68.3526 49.8095 68.3371 46.0687 66.0201 43.7708C63.7032 41.473 59.9624 41.4886 57.6644 43.8055C55.3666 46.1226 55.3822 49.8634 57.6991 52.1612C60.0161 54.4589 63.7571 54.4434 66.0548 52.1265Z",
    fill: "url(#paint13_linear_2407_17954)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9866 51.9258C68.2717 49.6217 68.2562 45.9017 65.9522 43.6168C63.6483 41.3318 59.9282 41.3472 57.6431 43.6512C55.3582 45.9552 55.3737 49.6753 57.6775 51.9603C59.9815 54.2452 63.7017 54.2297 65.9866 51.9258Z",
    fill: "#D4D4D4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0078 51.9474C68.2648 49.6717 68.2495 45.9972 65.9738 43.7404C63.6982 41.4834 60.0237 41.4988 57.7667 43.7744C55.5098 46.0501 55.5251 49.7245 57.8008 51.9814C60.0764 54.2384 63.7508 54.2232 66.0078 51.9474Z",
    fill: "url(#paint14_linear_2407_17954)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5876 51.0083C56.812 49.2474 56.8001 46.37 58.561 44.5944C60.3219 42.8188 63.1993 42.8069 64.9749 44.5678C66.7505 46.3287 66.7624 49.2061 65.0015 50.9817C63.2406 52.7573 60.3632 52.7692 58.5876 51.0083Z",
    fill: "#76C9F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7519 50.9659C57.0484 49.2765 57.037 46.5159 58.7264 44.8125C60.4158 43.109 63.1764 43.0975 64.8798 44.787C66.5833 46.4763 66.5947 49.2368 64.9053 50.9404C63.2159 52.6439 60.4553 52.6554 58.7519 50.9659Z",
    fill: "url(#paint15_linear_2407_17954)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2407_17954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 43,
    width: 10,
    height: 10
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7519 50.9659C57.0484 49.2765 57.037 46.5159 58.7264 44.8125C60.4158 43.109 63.1764 43.0975 64.8798 44.787C66.5833 46.4763 66.5947 49.2368 64.9053 50.9404C63.2159 52.6439 60.4553 52.6554 58.7519 50.9659Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2407_17954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8251 44.4355L56.1797 48.6952L56.8712 50.2607L66.5164 46.0009L65.8251 44.4355Z",
    fill: "url(#paint16_linear_2407_17954)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2407_17954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 43,
    width: 10,
    height: 10
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7519 50.9659C57.0484 49.2765 57.037 46.5159 58.7264 44.8125C60.4158 43.109 63.1764 43.0975 64.8798 44.787C66.5833 46.4763 66.5947 49.2368 64.9053 50.9404C63.2159 52.6439 60.4553 52.6554 58.7519 50.9659Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2407_17954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7878 46.8564L57.1426 51.1161L57.4905 51.904L67.1358 47.6443L66.7878 46.8564Z",
    fill: "url(#paint17_linear_2407_17954)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1114 44.5205C58.1395 44.3865 58.0538 44.2551 57.9199 44.227C57.7859 44.1989 57.6545 44.2846 57.6264 44.4185C57.5983 44.5525 57.684 44.6838 57.8179 44.712C57.9519 44.7402 58.0833 44.6544 58.1114 44.5205Z",
    fill: "#A3A3A3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.25 45.8769C57.2782 45.743 57.1924 45.6116 57.0586 45.5835C56.9246 45.5553 56.7932 45.6411 56.7651 45.7749C56.737 45.9089 56.8227 46.0403 56.9566 46.0684C57.0904 46.0967 57.2219 46.0109 57.25 45.8769Z",
    fill: "#A3A3A3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0879 43.583C59.116 43.449 59.0303 43.3176 58.8965 43.2895C58.7625 43.2614 58.6311 43.3471 58.603 43.481C58.5749 43.615 58.6606 43.7463 58.7944 43.7745C58.9283 43.8027 59.0597 43.717 59.0879 43.583Z",
    fill: "#A3A3A3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0281 48.8168C56.9405 48.7116 56.7843 48.6973 56.6791 48.785C56.5739 48.8726 56.5596 49.0288 56.6473 49.134C56.7349 49.2392 56.8911 49.2534 56.9963 49.1658C57.1015 49.0782 57.1158 48.922 57.0281 48.8168Z",
    fill: "#A3A3A3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5574 50.3344C57.4698 50.2292 57.3136 50.2149 57.2084 50.3025C57.1032 50.3902 57.0889 50.5464 57.1766 50.6516C57.2642 50.7568 57.4204 50.771 57.5256 50.6834C57.6308 50.5958 57.6451 50.4396 57.5574 50.3344Z",
    fill: "#A3A3A3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9266 47.2289C56.8389 47.1237 56.6827 47.1094 56.5775 47.1971C56.4723 47.2847 56.4581 47.4409 56.5457 47.5461C56.6333 47.6513 56.7896 47.6656 56.8947 47.5779C56.9999 47.4903 57.0142 47.3339 56.9266 47.2289Z",
    fill: "#A3A3A3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6305 52.3449C59.4937 52.3492 59.3864 52.4638 59.3908 52.6005C59.3951 52.7372 59.5097 52.8446 59.6464 52.8402C59.7831 52.8358 59.8905 52.7213 59.8861 52.5846C59.8816 52.4478 59.7672 52.3405 59.6305 52.3449Z",
    fill: "#A3A3A3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.152 52.8605C61.0152 52.8649 60.9079 52.9794 60.9122 53.1161C60.9166 53.2528 61.031 53.3602 61.1679 53.3558C61.3046 53.3515 61.412 53.2369 61.4076 53.1002C61.4032 52.9635 61.2887 52.8561 61.152 52.8605Z",
    fill: "#A3A3A3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.316 51.4474C58.1793 51.4518 58.0719 51.5663 58.0763 51.703C58.0807 51.8398 58.1952 51.9471 58.3319 51.9428C58.4687 51.9384 58.5761 51.8239 58.5717 51.6871C58.5673 51.5504 58.4529 51.443 58.316 51.4474Z",
    fill: "#A3A3A3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0428 52.4316C63.9613 52.5415 63.9845 52.6968 64.0946 52.7781C64.2046 52.8594 64.3599 52.8363 64.4412 52.7263C64.5227 52.6163 64.4994 52.461 64.3894 52.3797C64.2794 52.2983 64.1241 52.3214 64.0428 52.4316Z",
    fill: "#A3A3A3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3142 51.5692C65.2328 51.6791 65.2561 51.8344 65.3661 51.9157C65.4761 51.9972 65.6313 51.9739 65.7126 51.8639C65.7941 51.7539 65.7708 51.5986 65.6608 51.5173C65.5508 51.436 65.3957 51.4592 65.3142 51.5692Z",
    fill: "#A3A3A3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5428 52.8534C62.4613 52.9634 62.4846 53.1186 62.5946 53.2C62.7046 53.2814 62.8598 53.2581 62.9412 53.1481C63.0226 53.0381 62.9993 52.8829 62.8893 52.8016C62.7792 52.7201 62.6241 52.7434 62.5428 52.8534Z",
    fill: "#A3A3A3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6342 49.0896C66.667 49.2225 66.8014 49.3035 66.9342 49.2707C67.067 49.238 67.1481 49.1036 67.1153 48.9707C67.0825 48.8378 66.9481 48.7567 66.8154 48.7895C66.6825 48.8224 66.6015 48.9567 66.6342 49.0896Z",
    fill: "#A3A3A3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8002 47.6178C66.833 47.7506 66.9674 47.8317 67.1002 47.7989C67.2331 47.7661 67.3141 47.6317 67.2813 47.499C67.2486 47.3661 67.1142 47.285 66.9814 47.3178C66.8485 47.3506 66.7675 47.4849 66.8002 47.6178Z",
    fill: "#A3A3A3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1284 50.5613C66.1611 50.6941 66.2955 50.7752 66.4283 50.7424C66.5612 50.7096 66.6422 50.5752 66.6095 50.4423C66.5767 50.3095 66.4423 50.2284 66.3095 50.2612C66.1766 50.2941 66.0956 50.4285 66.1284 50.5613Z",
    fill: "#A3A3A3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9456 44.9039C66.0706 44.9597 66.2172 44.9036 66.273 44.7786C66.3288 44.6537 66.2727 44.5071 66.1478 44.4513C66.0229 44.3955 65.8762 44.4516 65.8204 44.5765C65.7646 44.7016 65.8207 44.848 65.9456 44.9039Z",
    fill: "#A3A3A3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8206 43.7847C64.9456 43.8406 65.0922 43.7845 65.148 43.6595C65.2038 43.5346 65.1477 43.388 65.0228 43.3322C64.8979 43.2764 64.7512 43.3323 64.6954 43.4574C64.6396 43.5825 64.6957 43.7289 64.8206 43.7847Z",
    fill: "#A3A3A3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6038 46.2847C66.7288 46.3405 66.8754 46.2846 66.9312 46.1595C66.987 46.0346 66.9309 45.888 66.806 45.8321C66.6811 45.7763 66.5344 45.8324 66.4786 45.9574C66.4228 46.0823 66.4789 46.2289 66.6038 46.2847Z",
    fill: "#A3A3A3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9172 42.8649C62.0385 42.8016 62.0855 42.6518 62.0222 42.5306C61.9588 42.4093 61.809 42.3623 61.6878 42.4257C61.5666 42.489 61.5195 42.6388 61.5829 42.76C61.6462 42.8814 61.7959 42.9283 61.9172 42.8649Z",
    fill: "#A3A3A3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3801 43.1335C60.5014 43.0701 60.5484 42.9204 60.485 42.7991C60.4217 42.6779 60.2719 42.6309 60.1507 42.6942C60.0295 42.7576 59.9824 42.9073 60.0458 43.0286C60.1091 43.1499 60.2588 43.197 60.3801 43.1335Z",
    fill: "#A3A3A3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5208 43.0915C63.642 43.0282 63.689 42.8784 63.6257 42.7572C63.5623 42.6358 63.4125 42.5889 63.2913 42.6522C63.1701 42.7156 63.123 42.8654 63.1864 42.9866C63.2498 43.108 63.3995 43.155 63.5208 43.0915Z",
    fill: "#A3A3A3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0586 44.4687C58.0868 44.3348 58.001 44.2034 57.8672 44.1753C57.7332 44.1471 57.6018 44.2329 57.5737 44.3667C57.5456 44.5007 57.6313 44.6321 57.7652 44.6602C57.8991 44.6883 58.0305 44.6026 58.0586 44.4687Z",
    fill: "#D4D4D4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1973 45.8252C57.2254 45.6912 57.1397 45.5598 57.0059 45.5317C56.8719 45.5036 56.7405 45.5893 56.7124 45.7232C56.6843 45.8571 56.77 45.9885 56.9038 46.0166C57.0377 46.0449 57.1692 45.9592 57.1973 45.8252Z",
    fill: "#D4D4D4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0352 43.5312C59.0633 43.3974 58.9776 43.2659 58.8437 43.2378C58.7098 43.2096 58.5784 43.2954 58.5503 43.4292C58.5221 43.5632 58.6079 43.6946 58.7417 43.7227C58.8756 43.7509 59.0069 43.6652 59.0352 43.5312Z",
    fill: "#D4D4D4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9754 48.765C56.8878 48.6598 56.7315 48.6456 56.6264 48.7332C56.5212 48.8208 56.5069 48.9771 56.5945 49.0822C56.6822 49.1874 56.8384 49.2017 56.9436 49.1141C57.0488 49.0266 57.063 48.8702 56.9754 48.765Z",
    fill: "#D4D4D4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5047 50.2826C57.417 50.1774 57.2608 50.1632 57.1557 50.2508C57.0505 50.3384 57.0362 50.4946 57.1238 50.5998C57.2115 50.705 57.3677 50.7193 57.4729 50.6316C57.5781 50.544 57.5923 50.3878 57.5047 50.2826Z",
    fill: "#D4D4D4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8738 47.1771C56.7862 47.0719 56.63 47.0577 56.5248 47.1453C56.4196 47.233 56.4053 47.3892 56.493 47.4943C56.5806 47.5995 56.7368 47.6138 56.842 47.5262C56.9472 47.4385 56.9615 47.2823 56.8738 47.1771Z",
    fill: "#D4D4D4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5777 52.2931C59.441 52.2975 59.3336 52.4119 59.338 52.5487C59.3424 52.6855 59.4569 52.7928 59.5937 52.7885C59.7304 52.7841 59.8378 52.6696 59.8334 52.5328C59.8289 52.3961 59.7145 52.2887 59.5777 52.2931Z",
    fill: "#D4D4D4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0992 52.8087C60.9625 52.8131 60.8551 52.9276 60.8595 53.0644C60.8639 53.2011 60.9784 53.3085 61.1151 53.3041C61.2519 53.2997 61.3593 53.1853 61.3549 53.0484C61.3505 52.9117 61.236 52.8043 61.0992 52.8087Z",
    fill: "#D4D4D4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2633 51.3956C58.1266 51.4 58.0192 51.5145 58.0236 51.6513C58.028 51.788 58.1425 51.8954 58.2792 51.891C58.4159 51.8866 58.5233 51.7721 58.5189 51.6354C58.5145 51.4985 58.4002 51.3911 58.2633 51.3956Z",
    fill: "#D4D4D4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M63.99 52.3798C63.9086 52.4898 63.9319 52.645 64.0419 52.7264C64.1519 52.8078 64.3071 52.7845 64.3884 52.6745C64.4699 52.5645 64.4466 52.4093 64.3366 52.328C64.2266 52.2465 64.0714 52.2697 63.99 52.3798Z",
    fill: "#D4D4D4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2615 51.5174C65.1801 51.6274 65.2034 51.7826 65.3134 51.864C65.4233 51.9454 65.5786 51.9221 65.6599 51.8121C65.7414 51.7021 65.7181 51.5469 65.6081 51.4656C65.4981 51.3842 65.343 51.4074 65.2615 51.5174Z",
    fill: "#D4D4D4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M62.49 52.8017C62.4086 52.9117 62.4319 53.0669 62.5419 53.1482C62.6519 53.2297 62.8071 53.2064 62.8884 53.0964C62.9699 52.9864 62.9466 52.8312 62.8366 52.7498C62.7267 52.6684 62.5715 52.6915 62.49 52.8017Z",
    fill: "#D4D4D4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5815 49.0378C66.6143 49.1707 66.7487 49.2518 66.8814 49.219C67.0143 49.1862 67.0954 49.0518 67.0626 48.9189C67.0298 48.786 66.8954 48.705 66.7627 48.7377C66.6298 48.7707 66.5487 48.9049 66.5815 49.0378Z",
    fill: "#D4D4D4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7475 47.566C66.7803 47.6989 66.9147 47.7799 67.0474 47.7472C67.1803 47.7144 67.2614 47.58 67.2286 47.4472C67.1958 47.3143 67.0614 47.2333 66.9287 47.2661C66.7959 47.2988 66.7147 47.4331 66.7475 47.566Z",
    fill: "#D4D4D4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0756 50.5095C66.1084 50.6424 66.2428 50.7234 66.3756 50.6907C66.5085 50.6579 66.5895 50.5235 66.5567 50.3906C66.524 50.2577 66.3896 50.1766 66.2568 50.2094C66.1239 50.2423 66.0429 50.3767 66.0756 50.5095Z",
    fill: "#D4D4D4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8929 44.8521C66.0178 44.9079 66.1645 44.8518 66.2203 44.7269C66.2761 44.602 66.22 44.4553 66.0951 44.3995C65.9701 44.3437 65.8235 44.3998 65.7677 44.5247C65.7119 44.6498 65.768 44.7963 65.8929 44.8521Z",
    fill: "#D4D4D4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7679 43.733C64.8928 43.7888 65.0394 43.7328 65.0953 43.6078C65.1511 43.4828 65.095 43.3362 64.9701 43.2804C64.8451 43.2246 64.6985 43.2805 64.6427 43.4056C64.5869 43.5307 64.643 43.6772 64.7679 43.733Z",
    fill: "#D4D4D4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5511 46.233C66.676 46.2888 66.8227 46.2327 66.8785 46.1077C66.9343 45.9828 66.8783 45.8362 66.7533 45.7804C66.6283 45.7246 66.4817 45.7807 66.4259 45.9056C66.3701 46.0305 66.4262 46.1771 66.5511 46.233Z",
    fill: "#D4D4D4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8645 42.8132C61.9857 42.7498 62.0328 42.6 61.9694 42.4788C61.9061 42.3576 61.7563 42.3105 61.6351 42.3739C61.5138 42.4373 61.4668 42.587 61.5301 42.7083C61.5935 42.8296 61.7431 42.8765 61.8645 42.8132Z",
    fill: "#D4D4D4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3274 43.0827C60.4486 43.0193 60.4957 42.8696 60.4323 42.7483C60.3689 42.6271 60.2192 42.5801 60.098 42.6434C59.9767 42.7068 59.9297 42.8565 59.993 42.9778C60.0564 43.099 60.206 43.1461 60.3274 43.0827Z",
    fill: "#D4D4D4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M63.468 43.0397C63.5892 42.9764 63.6363 42.8266 63.5729 42.7054C63.5096 42.5841 63.3598 42.5371 63.2386 42.6005C63.1173 42.6638 63.0703 42.8136 63.1337 42.9348C63.197 43.0562 63.3468 43.1031 63.468 43.0397Z",
    fill: "#D4D4D4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9619 44.2374L57.6348 44.5645L57.6698 44.5995L57.9969 44.2724L57.9619 44.2374Z",
    fill: "#B9B9B9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1005 45.5938L56.7734 45.9209L56.8084 45.9559L57.1355 45.6288L57.1005 45.5938Z",
    fill: "#B9B9B9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9384 43.2999L58.6113 43.627L58.6463 43.662L58.9734 43.3349L58.9384 43.2999Z",
    fill: "#B9B9B9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9306 48.7432L56.6035 49.0703L56.6385 49.1053L56.9656 48.7782L56.9306 48.7432Z",
    fill: "#B9B9B9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4599 50.2598L57.1328 50.5869L57.1678 50.6219L57.4949 50.2948L57.4599 50.2598Z",
    fill: "#B9B9B9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M56.829 47.1553L56.502 47.4824L56.537 47.5174L56.8641 47.1903L56.829 47.1553Z",
    fill: "#B9B9B9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7314 52.3604L59.4043 52.6875L59.4393 52.7225L59.7664 52.3954L59.7314 52.3604Z",
    fill: "#B9B9B9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2529 52.8751L60.9258 53.2021L60.9608 53.2372L61.2879 52.9101L61.2529 52.8751Z",
    fill: "#B9B9B9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4169 51.4629L58.0898 51.79L58.1249 51.825L58.4519 51.498L58.4169 51.4629Z",
    fill: "#B9B9B9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3349 52.3467L64.0078 52.6738L64.0428 52.7088L64.3699 52.3817L64.3349 52.3467Z",
    fill: "#B9B9B9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6064 51.4825L65.2793 51.8096L65.3143 51.8446L65.6414 51.5175L65.6064 51.4825Z",
    fill: "#B9B9B9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8349 52.7686L62.5078 53.0957L62.5428 53.1307L62.8699 52.8036L62.8349 52.7686Z",
    fill: "#B9B9B9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9677 48.7979L66.6406 49.125L66.6756 49.16L67.0027 48.8329L66.9677 48.7979Z",
    fill: "#B9B9B9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1337 47.3262L66.8066 47.6533L66.8416 47.6883L67.1687 47.3612L67.1337 47.3262Z",
    fill: "#B9B9B9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4619 50.2706L66.1348 50.5977L66.1698 50.6327L66.4969 50.3056L66.4619 50.2706Z",
    fill: "#B9B9B9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1415 44.4454L65.8145 44.7725L65.8495 44.8075L66.1766 44.4804L66.1415 44.4454Z",
    fill: "#B9B9B9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0146 43.3262L64.6875 43.6533L64.7225 43.6883L65.0496 43.3612L65.0146 43.3262Z",
    fill: "#B9B9B9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7978 45.8262L66.4707 46.1533L66.5057 46.1883L66.8328 45.8612L66.7978 45.8262Z",
    fill: "#B9B9B9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8955 42.4131L61.5684 42.7402L61.6034 42.7752L61.9305 42.4482L61.8955 42.4131Z",
    fill: "#B9B9B9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3583 42.6817L60.0312 43.0088L60.0663 43.0438L60.3933 42.7167L60.3583 42.6817Z",
    fill: "#B9B9B9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M63.499 42.6397L63.1719 42.9668L63.2069 43.0018L63.534 42.6747L63.499 42.6397Z",
    fill: "#B9B9B9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M76.9734 32.6742C76.9734 32.6742 75.6212 31.5681 69.9201 32.4926C63.8984 33.469 60.0764 37.1715 57.4737 39.7454C54.1062 43.0755 48.5528 50.7382 45.9277 57.2609C45.9277 57.2609 58.0443 31.8413 76.9734 32.6742Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M46.6222 57.935L46.0227 58.5239L45.8125 58.3184L46.4026 57.7246L46.6222 57.935Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2407_17954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 32,
    width: 33,
    height: 32
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2147 39.7099C78.0934 34.0139 76.9734 32.6742 76.9734 32.6742C76.9734 32.6742 75.6212 31.5681 69.9201 32.4926C63.8984 33.469 60.0764 37.1715 57.4737 39.7454C54.7869 42.4024 50.7087 47.8173 47.8364 53.2109C47.1087 54.5774 46.4583 55.9424 45.9277 57.2609L49.2779 60.541L52.5936 63.8559C59.1085 61.1819 66.7415 55.5766 70.0506 52.1889C72.6083 49.5706 76.2866 45.7261 77.2147 39.7099Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2407_17954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5938 63.8556C52.5938 63.8556 76.7676 51.6039 76.9736 32.6738L83.7958 35.6679L61.2184 70.4356C61.2184 70.4356 56.6672 68.7265 52.5938 63.8556Z",
    fill: "url(#paint18_linear_2407_17954)"
  })))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5938 63.8555L53.0711 65.5921C53.0711 65.5921 57.7201 63.3002 60.5698 59.5947C60.5698 59.5947 55.424 62.681 52.5938 63.8555Z",
    fill: "url(#paint19_linear_2407_17954)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M50.4893 70.8254C51.9185 69.4255 52.4545 68.0728 52.5482 67.8145C52.5268 67.8688 52.4785 67.9755 52.3738 68.1515C52.055 68.737 51.5827 69.3721 50.9094 70.118C50.0513 71.0686 48.8067 72.3307 48.625 72.8754C48.5911 72.9912 48.6081 73.0655 48.6602 73.1127C48.6606 73.113 48.6608 73.1134 48.6612 73.1135C48.662 73.1102 48.9036 72.3786 50.4893 70.8254Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2407_17954",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2407_17954"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2407_17954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2407_17954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2407_17954",
    x1: 31.2942,
    y1: 78.2607,
    x2: 45.4521,
    y2: 64.9249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#FFD052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2407_17954",
    x1: 37.7653,
    y1: 72.2191,
    x2: 46.4921,
    y2: 63.6331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#FFD052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2407_17954",
    x1: 54.0614,
    y1: 67.8962,
    x2: 45.8919,
    y2: 54.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767B7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2407_17954",
    x1: 41.8742,
    y1: 53.5151,
    x2: 54.9656,
    y2: 68.4768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F02E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2407_17954",
    x1: 55.732,
    y1: 72.0855,
    x2: 51.5246,
    y2: 50.8836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F02E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2407_17954",
    x1: 59.5705,
    y1: 40.4859,
    x2: 69.2557,
    y2: 63.3604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#EEF4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDDEED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2407_17954",
    x1: 60.8949,
    y1: 43.0218,
    x2: 69.1114,
    y2: 62.4276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#EEF4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDDEED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2407_17954",
    x1: 45.4411,
    y1: 52.382,
    x2: 54.1827,
    y2: 63.1675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2407_17954",
    x1: 51.8002,
    y1: 57.6658,
    x2: 53.589,
    y2: 63.1812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2407_17954",
    x1: 71.1396,
    y1: 34.5001,
    x2: 89.2151,
    y2: 48.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F02E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2407_17954",
    x1: 94.2194,
    y1: 65.9197,
    x2: 60.7566,
    y2: 31.2226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F02E54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2407_17954",
    x1: 93.2017,
    y1: 66.9008,
    x2: 59.7389,
    y2: 32.2037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F02E54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2407_17954",
    x1: 45.2081,
    y1: 57.86,
    x2: 55.4568,
    y2: 72.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F02E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2407_17954",
    x1: 62.9935,
    y1: 50.3399,
    x2: 66.6939,
    y2: 58.0877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6767,
    stopColor: "#1D262D",
    stopOpacity: 0.3233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2407_17954",
    x1: 59.196,
    y1: 41.5652,
    x2: 66.4647,
    y2: 58.5695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2407_17954",
    x1: 58.3311,
    y1: 42.551,
    x2: 66.9213,
    y2: 55.6787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C9F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2407_17954",
    x1: 66.0121,
    y1: 44.2597,
    x2: 56.8291,
    y2: 50.3403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2407_17954",
    x1: 67.1897,
    y1: 46.0359,
    x2: 58.0067,
    y2: 52.1166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2407_17954",
    x1: 83.759,
    y1: 60.2159,
    x2: 63.9536,
    y2: 47.8484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2407_17954",
    x1: 55.4218,
    y1: 59.46,
    x2: 57.4717,
    y2: 64.0524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D262D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunchIcon);
export default __webpack_public_path__ + "static/media/rocket_launch_icon.ada131243d13387e46bbb217d25b3c75.svg";
export { ForwardRef as ReactComponent };